import getCountArticles from "@ext/markdown/elements/view/render/logic/getCountArticles";
import getDisplayValue from "@ext/properties/logic/getDisplayValue";
import getGroupTitle from "@ext/properties/logic/grouping/getGroupTitle";
import { type Property, PropertyTypes, type ViewRenderGroup } from "@ext/properties/models";
import type { TableCell, TableRow } from "@ext/properties/models/table";

const getWidth = (property: Property) => {
	if (property.type === PropertyTypes.blockMd) return "20em";
	if (property.type === PropertyTypes.text) return "5em";
	return undefined;
};

const getArray = (
	group: ViewRenderGroup,
	select: string[],
	catalogProperties: Map<string, Property>,
	groupColumn: number,
	articleColumn: number,
): TableCell[] => {
	const rows = [];
	let row = [];

	if (group?.group?.length > 0)
		row.push({
			name: group.group[0] === null ? "" : getGroupTitle(group, catalogProperties),
			rowSpan: getCountArticles(group?.subgroups) ?? 1,
			column: groupColumn,
		});
	if (group?.subgroups?.length > 0) {
		group.subgroups.map((subgroup) => {
			row.push(...getArray(subgroup, select, catalogProperties, groupColumn + 1, articleColumn));
		});
	}
	if (group?.articles?.length > 0) {
		group.articles.forEach((article) => {
			const cells = select.map((name, index) => {
				const catalogProperty = catalogProperties.get(name);
				const property = article.otherProps.find((prop) => prop.name === name);
				const column = articleColumn + 1 + index;

				if (!property && !catalogProperty) return { name: "", rowSpan: 1, column };
				return {
					name: getDisplayValue(catalogProperty?.type, property?.value, Boolean(property)),
					itemPath: article.itemPath,
					rowSpan: 1,
					width: getWidth(catalogProperty),
					column,
				};
			});
			row.push({ article, column: articleColumn }, ...cells, "\n");
			rows.push(...row);
			row = [];
		});
	}

	rows.push(...row);
	return rows;
};

const splitRows = (rows: TableCell[]) => {
	const result = [];
	let currentGroup = [];

	for (const item of rows) {
		if (item === "\n") {
			if (currentGroup.length > 0) {
				result.push(currentGroup);
				currentGroup = [];
			}
		} else {
			currentGroup.push(item);
		}
	}

	if (currentGroup.length > 0) {
		result.push(currentGroup);
	}

	return result;
};

const getRenderRows = (
	group: ViewRenderGroup,
	select: string[],
	catalogProperties: Map<string, Property>,
	groupCount: number,
): Array<TableRow[]> => {
	return splitRows(getArray(group, select, catalogProperties, 0, groupCount));
};

export default getRenderRows;
